<template>
  <modal
    name="vehicle-list-modal"
    :height="isMobile ? '100%' : '70%'"
    :width="isMobile ? '100%' : '70%'"
    @before-open="handleBeforeOpen"
    @before-close="handleBeforeClose"
  >
    <div
      class="pb-2 pr-4 pt-4 pl-4 border-gray-100 dark:border-gray-500 dark:bg-gray-900 dark:text-gray-200"
    >
      <div class="w-full flex items-center justify-center">
        <button
          @click="active = 1"
          class="w-5/12 py-2"
          :class="active == 1 ? 'border-b-2 border-black' : ''"
        >
          ARAÇ LİSTESİ
        </button>
        <button
          @click="active = 2"
          class="w-5/12 py-2"
          :class="active == 2 ? 'border-b-2 border-black' : ''"
        >
          HARİTA
        </button>
        <button
          @click="active = 3"
          class="w-5/12 py-2"
          :class="active == 3 ? 'border-b-2 border-black' : ''"
        >
          DURUM
        </button>

        <div class="w-2/12 text-right">
          <button class="pb-1 px-2" @click="$modal.hide('vehicle-list-modal')">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
    </div>
    <locationDetail
      v-if="active == 2"
      :rowId="rowId"
      :activeAxios="activeAxios"
    />
    <actionDetail
      v-if="active == 3"
      :rowId="rowId"
      :activeAxios="activeAxios"
    />
    <vehicleList
      ref="vehicleListComponent"
      @refresh="handleRefresh"
      v-if="active == 1"
      :rowId="rowId"
      :isDisabled="isDisabled"
      :orderNo="orderNo"
      :customerList="customerList"
      :customers="customers"
      :orderItem="orderItem"
      :vehicleListType="vehicleListType"
      :isArchived="isArchived"
      @updateCounts="vehicleCounts = $event"
      @changeOrderReceivedTonnage="(val)=>$emit('changeOrderReceivedTonnage',val)"
    />
  </modal>
</template>

<script>
//Global Components
import locationDetail from "@/components/generate/map-location/index.vue";
import actionDetail from "@/components/generate/action-detail/index.vue";

//Local Components
import vehicleList from "./components/vehicleList.vue";
// asdfas

export default {
  props: [
    "rowId",
    "isDisabled",
    "orderNo",
    "customerList",
    "customers",
    "orderItem",
    "isArchived",
  ],
  components: {
    vehicleList,
    locationDetail,
    actionDetail,
  },
  data() {
    return {
      active: 1,
      activeAxios: 1,
      vehicleListType: 'active',
      vehicleCounts: {
        assigned: 0,
        available: 0,
        deleted: 0,
        rejected: 0
      },
      refreshInterval: null
    };
  },
  methods: {
    handleRefresh() {
      this.$emit("refresh", true);
    },
    handleBeforeOpen() {
      // Modal açılırken araç listesini refresh et
      this.$nextTick(() => {
        if (this.$refs.vehicleListComponent && this.$refs.vehicleListComponent.getAll) {
          this.$refs.vehicleListComponent.getAll(true);
        }
      });

      // Otorefresh başlat (25 saniyede bir)
      this.startAutoRefresh();
    },
    handleBeforeClose() {
      // Modal kapanırken otorefresh'i durdur
      this.stopAutoRefresh();
    },
    startAutoRefresh() {
      // Önceki interval varsa temizle
      this.stopAutoRefresh();

      // 25 saniyede bir araç listesini yenile
      this.refreshInterval = setInterval(() => {
        if (this.$refs.vehicleListComponent && this.$refs.vehicleListComponent.getAll) {
          this.$refs.vehicleListComponent.getAll(false);
        }
      }, 25000);
    },
    stopAutoRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    }
  },
  beforeDestroy() {
    // Component destroy edilirken interval'i temizle
    this.stopAutoRefresh();
  }
};
</script>